import { render } from "./CustomBottomSheet.vue?vue&type=template&id=5d0cb590"
import script from "./CustomBottomSheet.vue?vue&type=script&lang=js"
export * from "./CustomBottomSheet.vue?vue&type=script&lang=js"

import "./CustomBottomSheet.vue?vue&type=style&index=0&id=5d0cb590&lang=scss"
script.render = render

export default script